// extracted by mini-css-extract-plugin
module.exports = {"tools":"bK_hL","toolsContainer":"bK_hM","title":"bK_f","description":"bK_g","grid":"bK_bK","card":"bK_V","cardTitle":"bK_hJ","cardDescription":"bK_hK","icon":"bK_j"};